function FormatDateDurationForMessagesTime(dateString) {
  // MySQL strings ("YYYY-MM-DD HH:MM:SS") have no timezone — force UTC so
  // getHours() returns device-local time rather than treating UTC as local.
  let str = String(dateString || '').trim().replace(' ', 'T');
  if (str && !str.endsWith('Z') && !str.includes('+')) str += 'Z';
  const date = new Date(str);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const period = hours >= 12 ? "PM" : "AM";

  // Convert to 12-hour format
  if (hours > 12) {
    hours -= 12;
  } else if (hours === 0) {
    hours = 12;
  }

  // Add leading zero for single-digit minutes
  if (minutes < 10) {
    minutes = "0" + minutes;
  }

  return `${hours}:${minutes} ${period}`;
}

export default FormatDateDurationForMessagesTime;
